export var toNumber = function (value) {
    if (value === null || value === undefined || value === "") {
        return 0;
    }
    var numericValue = typeof value === "string" ? Number(value) : value;
    return Number.isNaN(numericValue) ? 0 : numericValue;
};
export var getDisplayedOrderTotal = function (cart, isCardPaymentSelected) {
    if (!cart) {
        return 0;
    }
    var baseTotal = toNumber(cart.total);
    var ncaFee = toNumber(cart.nca_fee);
    var deliveryTip = toNumber(cart.delivery_tip);
    var shouldIncludeNcaFee = isCardPaymentSelected && ncaFee > 0;
    return baseTotal + (shouldIncludeNcaFee ? ncaFee : 0) + deliveryTip;
};
